import { Component, Input,Output, EventEmitter, OnInit, OnChanges } from "@angular/core";
import {InsaCronService} from "../../../../../../insa-services";
import {ChronosActivityResultActions, ChronosActivitiesModel} from '../../../../../../insa-models';

@Component({
    selector: "edit-post-action",
    template: require("./edit-post-action.component.html")
})

export class EditPostActivityComponent implements OnInit {


    _selectedAct: ChronosActivitiesModel = new ChronosActivitiesModel();
    _postActData: ChronosActivityResultActions;
    _activities: ChronosActivitiesModel;
    _editedactivity: ChronosActivitiesModel = new ChronosActivitiesModel();

    @Output() emitIsComponentCreated: EventEmitter<any> = new EventEmitter<any>(true);
    @Output() addOrEditPostAction: EventEmitter<ChronosActivitiesModel> = new EventEmitter<ChronosActivitiesModel>(true);

    @Input() postActivity: ChronosActivityResultActions = new ChronosActivityResultActions();
    @Input() set selectedActivity(selact: any) {(selact !== undefined) ? this._selectedAct = selact : this._selectedAct = new ChronosActivitiesModel()}
    @Input() set postActionData(postact: any) { this._postActData = postact; }
    @Input() set activities(activities: any) { this._activities = activities; }
    @Input() set submittedActivity(sbmttdActivity: any) {this._editedactivity = sbmttdActivity;}
    @Input() prioritiesList: Array<Object>;

    editedActivity: ChronosActivitiesModel = new ChronosActivitiesModel();
    selectedPostActivity: ChronosActivityResultActions;
    private submitted: boolean = false;
    activityTypes: any;
    private priorities: any;
    private isActivityAddSelected: boolean = false;
    jobID: number = null;
    duplicatePostActivity: any[] = [];
    postActionDuplicate: boolean = false;

    constructor(private _insaChronosService: InsaCronService) { }

    /*private getData() {
        this._insaChronosService.getPriorities().subscribe((p) => {
            this.priorities = p;
        });
    }*/

     hideModal() {
         this.isActivityAddSelected = false;
     }

    checkPostActivity(){
        this.postActionDuplicate = false;
    }

    onSubmit(editedPostAction: any) {
        this.submitted = true;

        if (editedPostAction.invalid) {
            return;
        }

        if (this._selectedAct !== undefined) {
            this._selectedAct.PostActivities = this._postActData;

            if (this.selectedPostActivity.ActivityID !== null) {
                if (this.editedActivity.PostActivities != null && this.editedActivity.PostActivities != undefined) {
                    this.duplicatePostActivity = this.editedActivity.PostActivities.filter(function (dpa) {
                        return dpa.ActivityID == editedPostAction.ActivityID && dpa.PriorityID == editedPostAction.PriorityID && dpa.PostActivityID == editedPostAction.PostActivityID;
                    });

                    if (this.duplicatePostActivity.length < 1) {
                        this.editedActivity.PostActivities.filter((s, index) => {
                            if ((s.ActivityID == this.selectedPostActivity.ActivityID && s.PostActivityID == this.selectedPostActivity.PostActivityID && s.PriorityID == this.selectedPostActivity.PriorityID)) {
                                this._selectedAct.PostActivities.splice(index, 1)
                                return this._selectedAct.PostActivities;
                            }
                        })
                        this._selectedAct.PostActivities.push(editedPostAction);
                        this.addOrEditPostAction.emit(this._selectedAct);

                        this.isActivityAddSelected = false;
                        this.emitIsComponentCreated.emit(false);
                    } else {
                        console.log("bla");
                        this.postActionDuplicate = true;
                    }
                } else {
                    this.duplicatePostActivity = this._selectedAct.PostActivities.filter(function (dpa) {
                        return dpa.ActivityID == editedPostAction.ActivityID && dpa.PriorityID == editedPostAction.PriorityID && dpa.PostActivityID == editedPostAction.PostActivityID;
                    });

                    if (this.duplicatePostActivity.length < 1) {
                        this._selectedAct.PostActivities.filter((s, index) => {
                            if ((s.ActivityID == this.selectedPostActivity.ActivityID && s.PostActivityID == this.selectedPostActivity.PostActivityID && s.PriorityID == this.selectedPostActivity.PriorityID)) {
                                this._selectedAct.PostActivities.splice(index, 1)
                                return this._selectedAct.PostActivities;
                            }
                        })
                        this._selectedAct.PostActivities.push(editedPostAction);
                        this.addOrEditPostAction.emit(this._selectedAct);

                        this.isActivityAddSelected = false;
                        this.emitIsComponentCreated.emit(false);
                    } else {
                        console.log("bla");
                        this.postActionDuplicate = true;
                    }
                }
            } else {
                this.duplicatePostActivity = this._selectedAct.PostActivities.filter(function (dpan) {
                    return dpan.PriorityID == editedPostAction.PriorityID && dpan.PostActivityID == editedPostAction.PostActivityID
                })
                if (this.duplicatePostActivity.length < 1) {
                    let newPostAct: ChronosActivityResultActions = new ChronosActivityResultActions();

                    newPostAct.ActivityID = this._selectedAct.ActivityID;
                    newPostAct.PriorityID = editedPostAction.PriorityID;
                    newPostAct.PostActivityID = editedPostAction.PostActivityID;

                    this._selectedAct.PostActivities.push(newPostAct);
                    this.addOrEditPostAction.emit(this._selectedAct);

                    this.isActivityAddSelected = false;
                    this.emitIsComponentCreated.emit(false);
                } else {
                    console.log("bla");
                    this.postActionDuplicate = true;
                }
            }
        }
    }

    ngOnInit() {
        //this.getData();

        this.selectedPostActivity = JSON.parse(JSON.stringify(this.postActivity));
        this.editedActivity = JSON.parse(JSON.stringify(this._editedactivity));
    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-job-activities-form/insa-post-actions/post-action-form/edit-post-action.component.ts